var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {},
    [
      _c("Page", { attrs: { title: _vm.pageTitle } }, [
        _c("div", {}, [
          _c("div", [
            _c(
              "div",
              {
                staticClass: "Polaris-Box",
                staticStyle: {
                  "--pc-box-border-block-end": "var(--p-border-divider)",
                  "--pc-box-padding-inline-start-xs": "var(--p-space-2)",
                  "--pc-box-padding-inline-end-xs": "var(--p-space-2)"
                }
              },
              [
                _c(
                  "ul",
                  { staticClass: "Polaris-Tabs", attrs: { role: "tablist" } },
                  _vm._l(_vm.tabs, function(tab, index) {
                    return _c(
                      "li",
                      {
                        key: index,
                        staticClass: "Polaris-Tabs__TabContainer",
                        attrs: { role: "presentation" }
                      },
                      [
                        _c(
                          "router-link",
                          {
                            staticClass: "Polaris-Tabs__Tab",
                            attrs: {
                              role: "tab",
                              to: { name: tab.routeName },
                              type: "button",
                              tabindex: "0",
                              "exact-active-class":
                                "Polaris-Tabs__Tab--selected",
                              "aria-selected": "true",
                              "aria-controls": "all-customers-content-1",
                              "aria-label": "All customers"
                            }
                          },
                          [
                            _c("span", { staticClass: "Polaris-Tabs__Title" }, [
                              _vm._v(_vm._s(tab.label))
                            ])
                          ]
                        )
                      ],
                      1
                    )
                  }),
                  0
                )
              ]
            ),
            _c(
              "div",
              {
                staticClass: "Polaris-Tabs__Panel",
                attrs: {
                  id: "all-customers-content-1",
                  role: "tabpanel",
                  "aria-labelledby": "all-customers-1",
                  tabindex: "-1"
                }
              },
              [
                _c(
                  "div",
                  { staticClass: "Polaris-LegacyCard__Section" },
                  [_c("router-view")],
                  1
                )
              ]
            )
          ])
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }